import React from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { useMigrationEntityStatus } from '../../hooks';

import urlRoutes from '../../config/url-routes';

const disabledApproveButton = (envEntityStatus) => {
  const { migrationId, ...rest } = envEntityStatus;

  if(!migrationId) {
    return true;
  }

  return Object.keys(rest).some((item) => {
    if(!envEntityStatus[item]) {
      return true;
    }

    return false;
  });
}

const MigrationActions = () => {
  const { push } = useHistory();
  const { migrationId } = useParams();

  const { envEntityStatus } = useMigrationEntityStatus(migrationId);

  const listOptions = [
    {
      label: 'Recusar migração',
      variant: 'reject',
      action: () =>
        push({
          pathname: urlRoutes.changeMigrationRefuseStatusUrl.replace(/:migrationId/gi, migrationId),
        })
    },
    {
      label: 'Aprovar migração',
      variant: 'approve',
      disabled: disabledApproveButton(envEntityStatus),
      action: () =>
        push({
          pathname: urlRoutes.changeMigrationApproveStatusUrl.replace(/:migrationId/gi, migrationId),
        })
    }
  ]

  return (
    <div className='migration-actions'>
      {listOptions.map((item, index) => (
        <button
          key={index}
          className={`migration-actions__btn migration-actions__btn--${item.variant}`}
          disabled={item.disabled}
          title={item.disabled ? 'Marque como validado cada um dos itens ao lado para aprovar essa migração' : null}
          onClick={() => item.action()}
        >
          {item.label}
        </button>
      ))}
    </div>
  )
}

export default MigrationActions;
